import { useRef } from "react"
import { useNavigate } from "react-router-dom"

import { Button, ButtonSize } from "../../../../components/Button"
import { useTextStorage, useImagePreload } from "../../../../hooks"
import "./PortraitSection.scss"

import {
  services2Hq,
  services2Lq,
  services2Decor,
  services3Decor2,
  servicesDecorCircle,
  servicesDecorSpots,
} from "../../../../assets/images"

export const PortraitSection: React.FC = () => {
  const { ts } = useTextStorage()
  const navigate = useNavigate()

  const hqRef = useRef<HTMLImageElement>(null)
  useImagePreload(services2Hq, hqRef)

  const handleConnectButtonClick = () => {
    navigate("/#connect")
  }

  const handleGalleryButtonClick = () => {
    navigate("/gallery")
  }

  return (
    <div className="portrait-section">
      <h2>{ts.pages.services.sections[1].title}</h2>
      <div className="portrait-section--image-container">
        <img
          src={services2Lq}
          alt="portrait-section-pic-lq"
          className="portrait-section--lq"
        />
        <img
          ref={hqRef}
          src={services2Hq}
          alt="portrait-section-pic-hq"
          className="portrait-section--hq"
        />
        <img
          src={services3Decor2}
          alt="portrait-section-decor-top"
          className="portrait-section--decor-pic-top"
        />
        <img
          src={services2Decor}
          alt="portrait-section-decor-bottom"
          className="portrait-section--decor-pic-bottom"
        />
      </div>
      <div className="portrait-section--content">
        <h2>{ts.pages.services.sections[1].title}</h2>
        {ts.pages.services.sections[1].paragraphs.map((paragraph, i) => (
          <p key={`portrait-section--paragraph-${i}`}>{paragraph}</p>
        ))}
        <div className="portrait-section--content--buttons-container">
          <Button
            text={ts.pages.services.buttonTextConnect}
            size={ButtonSize.MD}
            onClick={handleConnectButtonClick}
          />
          <Button
            text={ts.pages.services.buttonTextGallery}
            size={ButtonSize.MD}
            onClick={handleGalleryButtonClick}
          />
        </div>
      </div>

      <img
        src={servicesDecorCircle}
        alt="portrait-section-decor-circle"
        className="portrait-section--decor-circle"
      />
      <img
        src={servicesDecorSpots}
        alt="portrait-section-decor-spots"
        className="portrait-section--decor-spots"
      />
    </div>
  )
}
